<template>
    <div class="">
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row mt-5">
            <div class="col-md-6 d-flex justify-content-end">
                <h4>{{ labels.fechaSaldos }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start" v-if="chkCierre == 1">
                <input type="month" v-model="fechaSaldos" class="form-control" readonly>
            </div>
            <div v-else>
                <input type="month" v-model="fechaSaldos" class="form-control">
            </div>
        </div>
        <b-row class="mt-4">
            <b-col class="d-flex justify-content-center">
                <md-button @click="generaSaldos" id="create-btn">{{ labels.procesar }}</md-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ContratoSaldos from '../../services/ContratoSaldos';
import FechaRegistro from '../../services/FechaRegistro';

export default {
    name : 'SaldosContables',
    data : () => ({
        fechaSaldos : '',
        chkCierre : 0
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Saldos contables',
                    fechaSaldos : 'Fecha saldos:',
                    procesar : 'Procesar',
                    noRow : 'No hay registros',
                }
            }else{
                return {
                    title : 'Accounting balances',
                    fechaSaldos : 'Balance date:',
                    procesar : 'Process',
                    noRow : 'There are no records',
                }
            }
        }
    },
    methods:{
        generaSaldos(){
            // console.log('generaSaldos');
            if (this.fechaSaldos == '') {
                this.$toast.error('Diligenciar la fecha.');
                return;
            }

            const datos = {
                fechaSaldos: this.fechaSaldos,
                idUser: this.$store.state.userId
            };
            // console.log(datos);

            ContratoSaldos.generaSaldosContables(datos)
            .then((res) => {
                // console.log(res.data);
                this.$toast.success(res.data.message)
            }).catch((err) => {
                console.log(err);
            });
        }
    },
    mounted(){

        FechaRegistro.getAllFechaRegistro()
        .then((res) => {
            // console.log(res.data);
            this.fechaSaldos = res.data.periodo_cierre
            this.chkCierre = res.data.flag_cierre
        })
        .catch((err) => {
            console.log(err);
            if(err.response.status == 500){
                this.$toast.error(err.response.data.msg)
            }else{
                this.$toast.error("Algo pasó, intentalo de nuevo")
            }
        })
    }
}
</script>

<style>

</style>